import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Sparkles } from "lucide-react";
import { SiteNav } from "@/components/site/SiteNav";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PageMeta } from "@/components/site/PageMeta";
import { PricingCards } from "@/components/site/PricingCards";
import { ConversionBand } from "@/components/site/ConversionBand";
import { TestimonialSpotlight } from "@/components/site/TestimonialSpotlight";
import { Reveal } from "@/hooks/useReveal";
import { OFFERS } from "@/content/offers";

const GUARANTEES = [
  { icon: ShieldCheck, label: "Selective intake — no high-pressure sales" },
  { icon: Sparkles, label: "Faith-informed · Business-driven · Confidential" },
];

const Invest = () => (
  <div className="min-h-screen bg-background text-foreground">
    <PageMeta
      title="Invest · Pricing & Programs — Dr. Sully Speaks"
      description={`Four pathways with Dr. Sully: Free Scan, ${OFFERS.masterclass.priceLabel} Masterclass, 1:1 coaching ${OFFERS.coaching.priceLabel.toLowerCase()}/mo, or org transformation ${OFFERS.enterprise.priceLabel.toLowerCase()}.`}
      path="/invest"
    />
    <SiteNav />

    <section className="relative pt-32 pb-12 md:pt-40 bg-hero overflow-hidden">
      <div className="container max-w-3xl text-center">
        <Reveal variant="up">
          <span className="eyebrow !mx-auto">Invest</span>
          <h1 className="font-display font-bold uppercase text-white text-4xl md:text-6xl mt-4 leading-[1.05]">
            Pick your <span className="text-gradient-gold">pathway.</span>
          </h1>
          <p className="text-silver text-base md:text-lg mt-5 max-w-xl mx-auto leading-relaxed">
            Four entry points. Each one designed to compound into the next.
            Start where you are — Dr. Sully meets you there.
          </p>
        </Reveal>

        <Reveal variant="fade" delay={120} className="mt-8 flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {GUARANTEES.map(({ icon: Icon, label }) => (
            <div key={label} className="inline-flex items-center gap-2 border border-gold/30 bg-navy-elevated/50 px-3 py-1.5">
              <Icon className="h-3.5 w-3.5 text-gold" />
              <span className="text-[11px] uppercase tracking-[0.2em] text-silver">{label}</span>
            </div>
          ))}
        </Reveal>
      </div>
    </section>

    <PricingCards />

    <TestimonialSpotlight />

    <ConversionBand
      eyebrow="Still Deciding?"
      heading="Start with the free Scan."
      subheading="The fastest way to see where Dr. Sully would meet you. Two minutes, personalized report, no credit card."
      primaryLabel="Take the Scan"
      primaryHref="/scan"
      secondaryLabel="Apply for Coaching"
      secondaryHref="/inquire?lane=coaching"
    />

    <div className="container py-10 text-center">
      <Link to="/" className="text-silver text-xs uppercase tracking-[0.25em] hover:text-white inline-flex items-center gap-2">
        <ArrowLeft className="h-3 w-3" /> Back to home
      </Link>
    </div>

    <SiteFooter />
  </div>
);

export default Invest;
